export default {
  methods: {
    $rules(rules) {
      return rules.filter(Boolean).join('|')
    }
  }
}